<div class="d-flex mb-2 align-items-center flex-wrap">
  <div *ngIf="!IsOverAll" class="d-flex flex-column flex-wrap">
    <h4 class="fs-16"><strong class="ml-1">{{TextcategoryOrSubcategoryName}}</strong> - <strong
        class="ml-1">{{TextTicketCount}} Tickets</strong></h4>
    <!-- <span>Total No of Tickets - <strong class="ml-1">{{TextTicketCount}}</strong></span> -->
  </div>
  <div class="align-self-center ml-auto fs-12">
    <div class="d-flex justify-content-end">
      <div class="deepdive-dropdown">
        <div class="dropdown-toggle" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <a href="javascript:;" role="button" class="btn btn-secondary iom-svg-icon ml-2">
            <span>Show/Hide Insights</span>
          </a>
        </div>
        <div class="dropdown-menu dropdown-md ScrollY" style="height: 250px; overflow: auto;"
          aria-labelledby="dropdownMenuButton">
          <div class="dropdown-item" href="#">
            <a href="javascript:;">
              <span>
                <label class="myw-checkbox">
                  <input (change)="ShowHideChart('all', '')" id="SelectAllInsights" type="checkbox" [checked]="1"
                    name="domain-optionall">
                  <span>Select All</span>
                </label>
              </span>
            </a>
          </div>
          <div *ngFor="let chart of chartTitleObject" class="dropdown-item" href="#">
            <a href="javascript:;">
              <span>
                <label class="myw-checkbox mr-5 ao-check">
                  <input type="checkbox" name="domain-insights" [checked]="chart.IsEnabled" value="{{chart.RowRanking}}"
                    (click)="ShowHideChart(chart.ChartHeading, chart.RowRanking)" style="cursor: pointer;">
                  <span>{{chart.ChartHeading}}</span>
                </label>
              </span>
            </a>
          </div>
          <div *ngFor="let chart of scChartTitleList" class="dropdown-item" href="#">
            <a href="javascript:;">
              <span>
                <label class="myw-checkbox mr-5 ao-check">
                  <span>{{chart.ChartHeading}}</span>
                </label>
              </span>
            </a>
          </div>
        </div>
      </div>
      <a href="javascript:;" (click)="LoadInsights()" role="button" data-bs-display="static"
        class="btn btn-secondary iom-svg-icon ml-3" style="cursor: pointer;">
        <span>Add Insights</span>
      </a>
    </div>
  </div>
</div>
<h4 class="fs-16 mb-3 ml-1">Standard Insights</h4>
<div class="row myw-grid">
  <div class="col-12 col-lg-6 d-flex" *ngFor="let item of sChartGraphData | keyvalue">
    <div class="card iom-card imo-card-edit">
      <div class="card-header">
        <h4 class="card-title">{{GetChartTitle(item.key)}}</h4><span class="rowranking"
          style="display:none;">{{GetRowRank(item.key, true)}}</span>
      </div>
      <div class="card-body" id="container_{{GetRowRank(item.key, true)}}">
        <div class="imo-card-chat">
          <app-d3-chart [Data]="item.value" [IsOverAll]="true" [Rowrank]="GetRowRank(item.key, true)"
            [IsEdit]="false">
          </app-d3-chart>
        </div>
      </div>
    </div>
  </div>
</div>
<hr class="iom-hr" />
<h4 class="fs-16 mb-4">Recommended Additional Insights</h4>
<div class="row myw-grid">
  <div class="col-12 col-lg-6 d-flex" *ngFor="let item of graphData | keyvalue">
    <div class="card iom-card imo-card-edit">
      <div class="card-header">
        <h4 class="card-title">{{GetChartTitle(item.key)}}</h4><span class="rowranking"
          style="display:none;">{{GetRowRank(item.key, true)}}</span>
        <a *ngIf="GetRowRank(item.key, true) != forecastRowRank" href="javascript:;" class="btn btn-icon" title="Hide"
          (click)="ShowHideChart(GetChartTitle(item.key),GetRowRank(item.key, true))">
          <img src="assets/images/hide.svg" alt="Hide" />
          <span class="sr-only">View</span>
        </a>
        <a *ngIf="GetRowRank(item.key, true) != forecastRowRank" href="javascript:;" class="btn btn-icon" title="Edit" role="button"
          (click)="EditInsight(GetRowRank(item.key, true),VersionId,GetChartTitle(item.key),'passObservation')">
          <img src="assets/images/edit.svg" alt="Edit" class="myw-icon myw-16" />
          <span class="sr-only">Edit</span>
        </a>
      </div>
      <div class="card-body" id="container_{{GetRowRank(item.key, true)}}">
        <div class="imo-card-chat">
          <app-d3-chart [Data]="item.value" [IsOverAll]="IsOverAll" [Rowrank]="GetRowRank(item.key, true)"
            [IsEdit]="false">
          </app-d3-chart>
        </div>
      </div>
    
      <div class="card-footer">
        <div class="d-flex justify-content-end">
          <div class="iom-navbar-tab justify-content-end">
            <a *ngIf="this.iomService.readonlyDD == false" href="javascript:;" class="btn btn-icon imo-border"
              (click)="EditObservation(GetObservation(item.key).ObservationId)" title="Edit">
              <img src="assets/images/edit.svg" id="editicon_{{GetObservation(item.key).ObservationId}}" alt="Edit"
                class="myw-icon myw-12">
              <span class="sr-only">Edit</span>
            </a>
            <a *ngIf="this.iomService.readonlyDD == true" href="javascript:;" class="btn btn-icon imo-border disabled"
              (click)="EditObservation(GetObservation(item.key).ObservationId)" title="Edit">
              <img src="assets/images/edit.svg" id="editicon_{{GetObservation(item.key).ObservationId}}" alt="Edit"
                class="myw-icon myw-12">
              <span class="sr-only">Edit</span>
            </a>
            <a href="javascript:;" (click)="ResetObservation(GetObservation(item.key).ObservationId)"
              class="btn btn-icon" title="Reset">
              <img src="assets/images/refresh.svg" alt="Refresh" class="myw-icon myw-12">
              <span class="sr-only">Refresh</span>
            </a>
          </div>
        </div>
        <div class="text-secondary myw-700 fs-12">Observation:</div>
        <!-- <div class="text-secondary fs-12">Assigned Group - 'CE-IDC-SUPPORT' contributes 1% of the tickets, Assigned       Group - 'CENTRICA-ENERGY-APPLICATIONS-MAINTENANCE' contributes 98% of the tickets, Assigned Group- 'Endur Support' contributes 0% of the tickets.</div> -->
        <div class="text-secondary fs-12 ScrollY pad-2" style="max-height: 55px; overflow-y: auto;"
          id="editobserv_{{GetObservation(item.key).ObservationId}}" contenteditable="false">
          {{GetObservation(item.key).ObservationDesc}}
        </div>
      </div>
    </div>
  </div>
</div>
<!--modal for insights-->
<div *ngIf="iomService.isLoadInsight">
  <app-add-insights (editInsightsEmitter)='editInsightsValues()'></app-add-insights>
</div>